import Switcher from "./utils/Switcher";

export default class Cart {
    public static onSummaryForm($uid: JQuery): void {
        (<any> $uid).form();

        (<any> window).Site.discover($uid);
    }

    public static onUserForm($uid: JQuery): void {
        const Site = (<any> window).Site;

        Switcher.init($('input[name="invoice"]', $uid), $('.cartuserform__invoice', $uid));
        Switcher.init($('input[name="account"]', $uid), $('.cartuserform__account', $uid));

        Site.setJobsInputs($uid);
        Site.discover($uid);

        (<any> $uid).form();

    }

    public static onUserVerifyForm($uid: JQuery): void {
        const Site = (<any> window).Site;

        Switcher.init($('input[name="invoice"]', $uid), $('.cartuserverifyform__invoice', $uid));

        Site.setJobsInputs($uid);
        Site.discover($uid);

        (<any> $uid).form();
    }

    public static onServicesForm($uid: JQuery): void {
        (<any> $uid).form();

        let $items = $('.cartservices__item', $uid);
        let $inputs = $('input', $items);

        function update() {
            $items.removeClass('cartservices__item--selected');

            $items.each(function () {
                let $item = $(this);
                let $input = $('input', $item);

                if ($input.is(':checked')) {
                    $item.addClass('cartservices__item--selected');
                }
            });
        }

        $inputs.change(update);

        update();

        (<any> window).Site.discover($uid);
    }

    public static onUser(): void {
        let $nav = $('.vcartuser__nav-item');
        let $tabs = $('.vcartuser__tab');

        function show(ix) {
            $nav.removeClass('vcartuser__nav-item--selected');
            $nav.eq(ix).addClass('vcartuser__nav-item--selected');

            $tabs.hide();
            $tabs.eq(ix).show();
        }

        $nav.click(function (e) {
            e.preventDefault();

            let $this = $(this);
            let ix = $this.index();

            show(ix);

            localStorage.setItem('cart.user.tab', ix.toString());
        });

        let ix: number;

        if (localStorage.getItem('cart.user.tab') != null) {
            ix = parseInt(localStorage.getItem('cart.user.tab'));
        } else {
            ix = 0;
        }

        show(ix);
    }

    public static onCartForm($uid: JQuery): void {
        (<any> window).Site.discover($uid);
    }

    public static onOrderPage(): void {
            const $items = $('.orderbreadcrumb__item');

            let sel = true;

            $items.each((ix, el) => {
                const $item = $(el);
                const $ix = $('span', $item);

                if ($item.hasClass('orderbreadcrumb__item--selected')) {
                    sel = false;
                }

                if (sel) {
                    $item.addClass('orderbreadcrumb__item--selected')
                }

                $ix.text((ix + 1) + '.');
            });
    }

    public static discover($parent?: JQuery): void {
        $('.js-addtocart', $parent).each(function() {
            (<any> $(this)).addToCart();
        });
    }
}
